import { useState } from 'react';

export function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4l3u2v7s74mkk8pdq50', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contato" className="bg-[#2C2C2C] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-20 py-16">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12">
          <div className="flex items-center gap-3 mb-4 lg:mb-0">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-leaf-line text-3xl text-[#7DD3C0]"></i>
            </div>
            <span className="text-xl font-semibold">Terapia Faz Bem</span>
          </div>
          <p className="text-[#B0B0B0]">Transformando vidas através do acolhimento profissional</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#E5E5E5]">Menu</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('hero')} className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer">
                  Início
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('sobre')} className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer">
                  Sobre Mim
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicos')} className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer">
                  Serviços
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('depoimentos')} className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer">
                  Depoimentos
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#E5E5E5]">Atendimento</h4>
            <ul className="space-y-2 text-[#B0B0B0]">
              <li>Terapia Individual</li>
              <li>Terapia de Casal</li>
              <li>Online</li>
              <li>Presencial</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#E5E5E5]">Fale Comigo</h4>
            <ul className="space-y-2 text-[#B0B0B0]">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-[#7DD3C0]"></i>
                <a href="tel:11941652251" className="hover:text-[#7DD3C0] transition-colors duration-300">
                  (11) 94165-2251
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-[#7DD3C0]"></i>
                <a href="mailto:terapiafazbem.may@gmail.com" className="hover:text-[#7DD3C0] transition-colors duration-300">
                  terapiafazbem.may@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2 mt-4">
                <i className="ri-time-line text-[#7DD3C0] mt-1"></i>
                <span>Seg-Sex, 8h-22h</span>
              </li>
            </ul>
          </div>

          <div className="text-right">
            <p className="text-sm text-[#B0B0B0] mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              © 2025 Terapia Faz Bem
            </p>
            <p className="text-sm text-[#B0B0B0] mb-4">Todos os direitos reservados</p>
            <div className="flex items-center justify-end gap-4">
              <a
                href="https://www.instagram.com/psimayarabenetero/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 underline cursor-pointer"
              >
                Instagram
              </a>
              <a
                href="https://wa.me/5511941652251"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer"
              >
                WhatsApp
              </a>
              <a
                href="mailto:terapiafazbem.may@gmail.com"
                className="text-[#B0B0B0] hover:text-[#7DD3C0] transition-colors duration-300 cursor-pointer"
              >
                Email
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#4A4A4A] pt-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/3fac52c7eeb64bf4f1e63f0746551f75.jpg"
                alt="Fachada do Consultório"
                className="w-full h-48 object-cover object-top"
              />
            </div>

            <div className="text-center">
              <h3 className="text-3xl lg:text-4xl font-bold leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Localização
                <br />
                Privilegiada
                <br />
                e Acessível
              </h3>
            </div>

            <div>
              <form id="newsletter-form" onSubmit={handleNewsletterSubmit} data-readdy-form className="space-y-3">
                <p className="text-[#B0B0B0] text-sm mb-2">
                  Receba dicas de bem-estar
                  <br />
                  e conteúdos exclusivos
                </p>
                <div className="flex gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Seu melhor email"
                    required
                    className="flex-1 px-4 py-3 bg-transparent border-2 border-[#4A4A4A] rounded-xl text-white placeholder-[#6B6B6B] focus:border-[#7DD3C0] focus:outline-none transition-colors duration-300"
                  />
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-[#7DD3C0] text-white px-6 py-3 rounded-xl hover:bg-[#6BC4B0] transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Inscrever
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
                {submitStatus === 'success' && (
                  <p className="text-green-400 text-sm">Inscrito com sucesso!</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-red-400 text-sm">Erro ao inscrever. Tente novamente.</p>
                )}
              </form>
            </div>
          </div>
        </div>

        <div className="mt-12 p-6 bg-[#3A3A3A] rounded-2xl">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-[#7DD3C0] rounded-full flex-shrink-0">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <div className="flex-1">
              <p className="text-white font-semibold mb-1">Endereço do Consultório</p>
              <p className="text-[#B0B0B0]">
                Av. Dr. Chucri Zaidan, 940 - 3° andar - Torre II - Vila Cordeiro, São Paulo - SP, 04583-110
              </p>
            </div>
            <div className="flex items-center gap-4 text-sm text-[#B0B0B0]">
              <div className="flex items-center gap-2">
                <i className="ri-parking-box-line text-[#7DD3C0]"></i>
                <span>Estacionamento no local</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-train-line text-[#7DD3C0]"></i>
                <span>Ao lado da Estação Morumbi</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#6B6B6B] hover:text-[#7DD3C0] transition-colors duration-300"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}